import React, { Component } from 'react'
import { t } from 'i18next'

export default class Pickers extends Component {
  constructor(props) {
    super(props)

    this.state = {
      h: null
    }
  }

  componentDidMount() {
    fetch('https://s3.eu-west-2.amazonaws.com/bizon-assets/houses.json')
      .catch(err => console.error(err))
      .then(r => r.json())
      .then(h => {
        this.setState({ h })
      })
  }

  render() {
    const { activeFilters, updateActiveHouse } = this.props
    const { h } = this.state

    if (!h) return false

    let data = h.filter(x => x.images && x.images.length > 0)

    if (activeFilters.style && activeFilters.style !== null) {
      data = data.filter(x => x.style === activeFilters.style)
    }

    if (activeFilters.levels && activeFilters.levels !== null) {
      data = data.filter(x => x.levels === activeFilters.levels)
    }

    if (activeFilters.usable_area_from && activeFilters.usable_area_from !== null) {
      data = data.filter(x => parseInt(x.usable_net.match(/^([^/]+)/g, ''), 10) > activeFilters.usable_area_from)
    }

    if (activeFilters.usable_area_to && activeFilters.usable_area_to !== null) {
      data = data.filter(x => parseInt(x.usable_net.match(/^([^/]+)/g, ''), 10) < activeFilters.usable_area_to)
    }

    if (activeFilters.building_area_from && activeFilters.building_area_from !== null) {
      data = data.filter(x => parseInt(x.building_area.replace(' m²', ''), 10) > activeFilters.building_area_from)
    }

    if (activeFilters.building_area_to && activeFilters.building_area_to !== null) {
      data = data.filter(x => parseInt(x.building_area.replace(' m²', ''), 10) < activeFilters.building_area_to)
    }

    if (activeFilters.roof_area_from && activeFilters.roof_area_from !== null) {
      data = data.filter(x => parseInt(x.roof_area.replace(' m²', ''), 10) > activeFilters.roof_area_from)
    }

    if (activeFilters.roof_area_to && activeFilters.roof_area_to !== null) {
      data = data.filter(x => parseInt(x.roof_area.replace(' m²', ''), 10) < activeFilters.roof_area_to)
    }

    if (activeFilters.roof_slope_from && activeFilters.roof_slope_from !== null) {
      data = data.filter(x => parseInt(x.roof_slope.replace(' °', ''), 10) > activeFilters.roof_slope_from)
    }

    if (activeFilters.roof_slope_to && activeFilters.roof_slope_to !== null) {
      data = data.filter(x => parseInt(x.roof_slope.replace(' °', ''), 10) < activeFilters.roof_slope_to)
    }

    return (
      <div className="pickers">
        {data.length > 0 ? data.map((x, i) => (
          <div key={`house-project-${i}`}
            className="project"
            onClick={() => updateActiveHouse(x)}>
            <img
              src={(`https://s3.eu-west-2.amazonaws.com/bizon-assets/Houses/${x.images[0].path.replace('full', 'thumbs/small')}`)}
              alt={x.title} />
            {x.title}
          </div>
        )) : (<p>{t('no_results_projects')}</p>)
        }
        <a href="http://z500.com/projects/" target="_blank" rel="noopener noreferrer" className="project project-more">Meer projecten →</a>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Houses/pickers.js